import { stringifyWorkEntityProperties } from '~/app/utils/parseWorkEntity'
import { WesService } from 'shared/services/WesService'
import type { DTT } from 'shared/types/vp/dtt'

export const createFavorite = async ({
  tenant,
  newFavorite,
  ownerId,
  authorizationHeader,
}: DTT.Mutations.WorkEntityService.CreateMutationVariables): Promise<string> =>
  WesService.addFavorite(tenant, stringifyWorkEntityProperties(newFavorite), ownerId, authorizationHeader)
